export const aboutData = {
  title: "About Me",
  role: "Aspiring Software & Machine Learning Engineer",
  description1: "I'm an aspiring Software Engineer with expertise in Machine Learning, Backend Development, and Embedded Systems. I'm currently pursuing my Bachelor's in Computer Science Engineering with a specialization in Artificial Intelligence and Machine Learning at KPR Institute of Engineering and Technology.",
  description2: "I'm passionate about leveraging technical skills, practical knowledge, and data-driven solutions to contribute effectively to innovative projects. My journey includes developing ML models, building web applications, working on embedded systems, and contributing to research publications.",
  stats: [
    { label: "Education", value: "B.E. Computer Science and Engineering (AIML)" },
    { label: "Location", value: "Coimbatore, India" },
  ]
};
